import { render, staticRenderFns } from "./CoomingSoon.vue?vue&type=template&id=7b269eed&"
import script from "./CoomingSoon.vue?vue&type=script&lang=js&"
export * from "./CoomingSoon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports